/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { useLanguage } from '@/providers/LanguageProvider';

import { Icons } from '@/components/icons';

export const StateObj = () => {
  const { messages } = useLanguage();
  const text = messages?.General;
  const stateObj = {
    planned: {
      name: text?.planned,
      color: { backgroundColor: '#8A2DA53D', color: '#CE8FE0' },
      img: Icons.CalendarAdd('stroke-none'),
    },
    under_development: {
      name: text?.under_development,
      color: { backgroundColor: '#015CDA29', color: '#4895FE' },
      img: Icons.Code('stroke-none'),
    },
    under_consideration: {
      name: text?.under_consideration,
      color: { backgroundColor: '#EFDA1F1F', color: '#F3E354' },
      img: Icons.Clipboard('stroke-none'),
    },
    not_started: {
      name: text?.not_started,
      color: { backgroundColor: '#DB750029', color: '#FFA947' },
      img: Icons.Clock('stroke-none'),
    },
    supported: {},
  };
  return stateObj;
};
